import * as React from 'react'
import type { SVGProps } from 'react'
function IconStadtkarte(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 568.4 569.8"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-10-117h596v842H-10z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
        <clipPath>
          <path d="M-11-117h595v842H-11z" />
        </clipPath>
      </defs>
      <g>
        <path
          d="m89 409 5 15 1 5-1 5-5 6-6 4-1-3-4-4 1-2-2-1-6-3-4-3c0-3-3-7-5-9l-2-1-2-2 3-2-7-5-3-2v-2h-1v-3l2-11h-3l-2-1v-1l-7-6v-3c-1 0-8 2-10 1l-1 2-2-1 1-3-2-1 2-5-5-4v-1l-6-5 1-1-4-4h1l-3-4 2-2-11-7 1-2-2-1 3-5 2 1 3-4v-1l6-6-8-9 3-4 1 1 2-3 1 2 3 2h1l10 6 5 2 1-4 4 4 3 2 4-5 3 2 4-2-4-4a1641 1641 0 0 1 16-20l2-2h1l3-1v-4h-2l4-7 7 2 1-1 3 4 3-3 2 3 4 6h2l4 6h1l3-2 1 1c12-6 37-20 47-27l2-2c2-1 9-7 11-7 5-2 17-7 20-10l7-5 17-12 17-46-18-9-2 2-3-24 7 3 8-16 9 5 5-7 3-2c2-1 4-4 6-4-4-5-8-6-9-13l9-4c3 0 7-1 10-3l8-10 13-12 8-8v-1l6-6 5-12 10 4 2-2-3-3 3-2 10-11 3 1 8-8 3 4 3-3 6-7 7-13 4 3v-1l2-2c3 2 14 10 16 13l7-8 2 3 6-4 2-3 3 3 1-3 2 2 6-3v1l3-3 2 2 8-5-1-1 9-7-1-2-2-12h6l1 6s4-3 5-2l1 3 5-2 3 8 2 2 2 1 2 4 12 6 1 4 5 1-2 5c0 1 2 5 1 6l-7 2 1 9 1 3-2 2v5l-3 2 1 1-16 10c-1 2-1 7-4 8l-3 1-3 3-2-1-13 8 10 9-6 12-6-2-4 11 6 3 6 1v8l5 10c3 3 3 2 4 6 7 3 6 3 9 10l4 6 1 2h4l7 1 3 2h5l5-2 1 2 2-1h1l2-2 3-1 6-5 4-2 4-4v-1l8-6 6-3 4-2 4-1v-16l10-2 18-1-1 2-1 3h3v3h5l2 1 12 2 6 9 4-5 6 4-1 1 2 3-1 1v4h-3l-1 6h-4l-2 1 2 8h-1l-1 2-6-1-2 6 2 1v6h-2l-4-2-2 2-4 1v7l-3 1 1 3c1 6-2 25 0 31l2 4 2 4-9 3v3c-4 1-9 3-13 6-5 5-7 10-6 18l2 7 17 25c1 5 2 10 0 15-3 4-8 6-12 7-8 2-17-3-23-8l-6-6c-1-2-4-5-6-5-12-2-18 2-27 9l-20 9 3 5 1 2c4 3 11 3 17 3v2h7l2 4 3 3v1l1 2 5 3c0 2 2 4 3 5l1 3-2 2-1 4h-3l-7 4-3 5-1 2-1 1-2 2-3 5-4 5-2 4-3 8 3 4 2 4-1 2 1 3-14 7v2l6 3-6 13-3 3h-4v4l2 1 2 2-1 3-5 1c-9 1-20 1-29 3l-3 1c-1 1-3 3-5 3l-8 1h-23l-16 6-5 1-8 1-7-1-1 1-11-1h-27l-4-1-3 1h-11c-2 1-4 2-7 1l-4 7-12 10-7 10-4 5-4 10-10-5-6-3c-5 16-13 34-12 50l2 16h-11l-8 1-1 2-3 1-4 3-3-9-8-18-12-3-5 1h-6l-13 2-8 2-10 3-12 6-20 1-6-18 5-2-5-13 8-4-1-5c11-7 45-29 57-33l-2-3 2-1-6-14 1 1 1-6-2-6 2-2 1-2-1-2-1-1c2-8 1-15-5-20-2-2-4-3-4-5h-2l-2-11-3-3-7-1-3-4h-4l-2-3-3-3 2-3-9-6-4 6c-1 6-3 12 0 18Z"
          style={{
            fill: 'inherit',
          }}
        />
        <path
          d="M534 298c-6-10-17-19-19-31-3-21 19-24 33-24v-3c-10 1-30 2-35 16l-1 4v4c0 9 7 18 12 25 6 6 11 14 8 23-5 7-15 10-22 7-15-6-16-23-37-19-2 1 4-14 3-14h-1l-4 12c0 3-4 4-6 5l4-14h-1l-5 15-5 4-4 3-14 6v1h-1c-5 1-13 6-19 6-2 0-8 0-7-1 2-2 8-1 11-3 4-1 18-8 21-11v-1c-1 0-31 19-27 10l13-7v-2l-15 8c-2 3-5 7-9 6h-13l-7-2-3-1-9-2c-12-1-23 6-31 14-2 3-8 7-10 8v1l-2 2-10 6v-1l10-7v-1l-12 7c-3 4-1 3-7 5l-8 2-5 2c-10 4-20 13-31 15h-6c-5 0-8-3-13-2-11 1-18 0-30-1l-12 1-1 1-9 1c-4-1-6 0-10-2-16-7-30-31-49-25l7-4h3c2 0 2 3 4 2 5-2 9-1 10-7v-7c-1-4 1-11 5-9 7 3 11-4 16-7 6-3 16-3 21-5 13-4 20-9 32-16l8-4c2-1 3-4 2-5v-2l3-4 2-4 2-1 3-8c1-3 5-5 2-9-9-14-9-17 0-30 3-4 3-13 10-12h14c4 0 6 0 10-2 4-3 4-9 10-11l8-8 4-8c2-8-5-10-6-20l2-4 1-2c1-5 5-10 7-13l4-2 7-4c7 2 7-2 13-3 5 0 7 2 10 5 2 1 4 4 7 3l5 1 5 6c1 1 0 3 2 4 4 0 6-4 8-6 1-3 1-8 4-8 7 0 0-5 3-7 1-2 3-1 4-4l2-2c5 0 8 3 12 4l10 2v-1l-10-2c-4-1-10-7-14-3 0 4-3 3-5 6-2 1 3 6-1 6-6 0-4 9-9 12-3 3-4 2-5-2l-4-4c-4-3-4-2-9-3-2 0-3-3-5-3l-2-2-3-2c-3-1 3-3 0-5-2-1-5-1-7-3l-1 1-4 1c-6 1 1 6-4 8-4-1-6 3-9 4-2 1-5 1-5 3l-5 7-3 8c-2 3-2 5-1 9 1 5 6 9 5 14l-2 4-7 10c-9 5-6 6-13 13l-6 2h-18c-7 0-7 9-9 12-7 9-11 16-4 27 5 7 5 6 1 13-1 1-1 7-4 8-1 1-1 3-3 3s0 3-2 4c-1 1-5-1-5 3l-2 3-1 5c-11 6-19 12-29 15-10 5-22 2-30 10v-1 1l-2 2v-2l-1 1 1 1c-7 6-10-1-14 3-7 8 6 20-10 22-2 1-3-2-5-2s-5 0-6 2c-10 4-16 15-24 21-12 7-27 18-32 31l-1 6h-1l2 12 2 7 3 6 1 6-2 7c-1 1-2 3-4 3v1l-12 8 2 3c4-3 14-10 17-14 2-6 3-6 2-12l-4-12c-2-3-3-9-3-13l1-6 1-2 2 1c-1-3 4-9 5-10l-1-1-5 8 9-13c7-7 19-12 25-19l7-8 3-2v-1c3-2 7-4 11-2 9 2 16 7 23 13 8 7 19 15 30 16l4-1h35c17-4 26 5 44-4 6-3 11-8 17-9v1l1-1 8-2v-1l-5 2h-2l-6 2h-1l3-2 12-3 6-1 7-2 14-10c6-7 14-15 23-19 8-5 18-2 26-1l35 4c11 0 20-6 29-9l13-9c4-2 7-2 13-3l11 2v-1c-7-4-16-1-22 0 2-2 9-5 12-5 13-2 15 9 25 15 15 12 40 0 32-20Z"
          style={{
            fill: '#8fb6e1',
          }}
        />
        <path
          d="M334 136c3-3-3-6 2-8h8c2 1 7 1 3 4-1 3-1 2-4 1-3 0-6 5-10 4l1-1Zm-93 148 2-3c0-3 3-2 4-2v4c0 1 0 3-2 3l-5 2 1-4Zm-7 89h-27v-1l7-1 6 1 4-1 10 1Zm142-51h-7c-2-1 8-2 7 0Z"
          style={{
            fill: '#8fb6e1',
          }}
        />
      </g>
    </svg>
  )
}
export default IconStadtkarte
